import { styled } from "@/root/stitches.config";

import FooterContacts from "./FooterContacts";
import FooterSocials from "./FooterSocials";
import FooterBio from "./FooterBio";
import backdrop from "@/assets/misc/footer.webp";
import backdropMobile from "@/assets/misc/footer-mobile.webp";

const Container = styled("footer", {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: "1rem",
    width: "100%",
    height: "fit-content",
    minHeight: "30vw",
    margin: "0 auto",
    padding: "5vw 2rem",
    paddingTop: "12.5vw",
    paddingBottom: "6.25vw",

    backgroundColor: "#252525",
    backgroundPosition: "top center",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",

    zIndex: "1",
    translate: "0 -15px",

    "@desktop": {
        backgroundImage: `
            linear-gradient(
                to bottom,
                rgba(242, 48, 5, 0) 0%,
                rgba(246, 179, 57, 0.18) 18%,
                rgba(246, 179, 57, 0.38) 35%,
                rgba(242, 48, 5, 0.50) 52%,
                rgba(140, 50, 10, 0.70) 68%,
                rgba(37, 37, 37, 0.88) 85%,
                #252525 100%
            ),
            url("${backdrop}")
        `,
    },

    "@laptop": {
        backgroundImage: `
            linear-gradient(
                to bottom,
                rgba(242, 48, 5, 0) 0%,
                rgba(246, 179, 57, 0.18) 18%,
                rgba(246, 179, 57, 0.38) 35%,
                rgba(242, 48, 5, 0.50) 52%,
                rgba(140, 50, 10, 0.70) 68%,
                rgba(37, 37, 37, 0.88) 85%,
                rgba(3, 0, 0, 0) 100%
            ),
            url("${backdrop}")
        `,
    },

    "@tablet": {
        backgroundImage: `
            linear-gradient(
                to bottom,
                rgba(242, 48, 5, 0) 0%,
                rgba(246, 179, 57, 0.18) 18%,
                rgba(246, 179, 57, 0.38) 35%,
                rgba(242, 48, 5, 0.50) 52%,
                rgba(140, 50, 10, 0.70) 68%,
                rgba(37, 37, 37, 0.88) 85%,
                #252525 100%
            ),
            url("${backdrop}")
        `,
    },

    "@mobile": {
        backgroundImage: `
            linear-gradient(
                to bottom,
                rgba(242, 48, 5, 0) 0%,
                rgba(246, 179, 57, 0.25) 20%,
                rgba(242, 48, 5, 0.50) 45%,
                rgba(140, 50, 10, 0.72) 65%,
                rgba(37, 37, 37, 0.90) 82%,
                #25252500 100%
            ),
            url("${backdropMobile}")
        `,
        paddingTop: "9vw",
        paddingBottom: "20vw",
    },
});

export default function Footer() {
    return (
        <Container>
            <FooterBio />
            <FooterContacts />
            <FooterSocials />
        </Container>
    );
}